import React from 'react';
import PropTypes from 'prop-types';
import { useApi, usePayment } from 'utils';

import { logo } from '../../../../assets/img';
import {
  Dialog,
  DIALOG_TYPES,
  showErrorAlert,
  Typography,
} from '../../../alf-design';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

const MakePayment = ({
  show,
  onClose,
  selectedPolicy,
  getPolicy,
  oneTimePayment = false,
}) => {
  const policyNumber = selectedPolicy?.policyNumber;
  const paymentDue =
    selectedPolicy?.billing?.pastDueAmount > 0 ||
    selectedPolicy?.billing?.currentDueAmount > 0 ||
    oneTimePayment;

  const api = useApi();

  const submitPayment = (body) => {
    api.withAuth
      .post(`/policies/${policyNumber}/payments`, body)
      .then((res) => {
        if (res.status === 200) {
          datadogRum.addAction('payment.submission.succeeded');

          if (getPolicy) {
            getPolicy(policyNumber, null, null, { force: true });
          }
        }
      })
      .catch((err) => {
        let message;
        if (err.response) {
          if (err.response.data.Errors.length > 0) {
            message = err.response.data.Errors[0].value;
          }
          message = err.response;
        } else if (err.request) {
          message =
            'Network error. Please check your connection and try again.';
        } else {
          message = 'Something went wrong submitting your payment.';
        }
        datadogRum.addError(err, {
          event_name: 'payment.submission.failed',
          http_status: err?.response?.status,
        });
        datadogLogs.logger.error(`Submit Payment - ${policyNumber}`, {
          err,
        });
        showErrorAlert({
          message: err?.response?.status,
          description: message,
        });
      });
  };

  const { handleOneIncPayment } = usePayment({
    submitPayment,
    getPolicy,
    policyNumber: selectedPolicy?.policyNumber,
    policySystem: selectedPolicy?.policySystem,
    oneTimePayment,
  });

  const handlePayment = () => {
    onClose();
    handleOneIncPayment(selectedPolicy, () => {});
  };

  if (!paymentDue) {
    return (
      <Dialog
        id="make-payment-no-due"
        type={DIALOG_TYPES.CONTENT}
        show={show}
        onClose={onClose}
        primaryButtonText="Go Back"
        ariaLabel="No payment due"
      >
        <div className="text-center py-8">
          <img
            src={logo}
            width="225"
            alt="Slide Insurance logo"
            className="mb-8 mx-auto"
          />
          <Typography className="!text-base">
            No payment is due. If you would like to make an advance payment,
            please call Customer Service at (800) 748-2030.
          </Typography>
        </div>
      </Dialog>
    );
  }

  return (
    <Dialog
      id="make-payment"
      type={DIALOG_TYPES.CONTENT}
      invokingElementId="payments-button"
      show={show}
      onClose={onClose}
      title="Payment Confirmation"
      primaryButtonText="Ok"
      secondaryButtonText="Go Back"
      onPrimaryClick={handlePayment}
      onSecondaryClick={onClose}
      ariaLabel="Payment confirmation"
      contentClassName="!block"
    >
      <Typography type="caption5" className="!m-0">
        I understand and agree that by clicking &quot;Ok&quot;, I am leaving
        mySlide to make a payment with a third-party payment processor.
      </Typography>
      <Typography type="caption5" className="mt-[24px] mb-[22px]">
        A 2.99% processing fee applies to card payments and will be retained by
        a third-party payment processor. There is no fee when selecting E-Check
        or choosing pay by check.
      </Typography>
    </Dialog>
  );
};

MakePayment.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  selectedPolicy: PropTypes.object,
  getPolicy: PropTypes.func,
  oneTimePayment: PropTypes.bool,
};

export default MakePayment;
